export default ["map-pin", "heart", "x", "star"]
